import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ModalRecording = styled.button<Props>`
  background: ${(props) =>
    props.focused ? `${Colors['modal']['button']['light']}` : 'none'};
  border: ${Colors['modal']['button']['light']} ${3 * Screen.widthRatio}px solid;
  border-radius: ${54 * Screen.widthRatio}px;
  color: ${(props) =>
    props.focused
      ? `${Colors['modal']['button']['text']}`
      : `${Colors['modal']['button']['light']}`};
  font-family: ${Fonts['regular']};
  font-size: ${36 * Screen.widthRatio}px;
  height: ${99 * Screen.widthRatio}px;
  width: ${498 * Screen.widthRatio}px;
  z-index: 1;
  margin-bottom: ${30 * Screen.widthRatio}px;
  &:hover {
    background: ${Colors['modal']['button']['light']};
    color: ${Colors['modal']['button']['text']};
  }
`;

export default ModalRecording;
